import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

export interface SkeepersUserData {
  email: string | undefined;
  contractNumber: string | undefined;
  offer: string | undefined;
  lang?: string;
}

/**
 * Encapsulates the 3 Skeepers scripts (user feedback).
 * Provided at route level — scoped to the contract-validation page only.
 */
@Injectable()
export class SkeepersService {
  private readonly SCRIPT_ID = 'MFBActor';
  private readonly SCRIPT_SRC = ['https://actor.cxr.skeepers.io/actor/', environment.skeepersTagId, '/action.js'].join(
    '',
  );

  private get mfb(): any {
    return (window as any).MFB;
  }

  private log(...args: unknown[]): void {
    if (environment.development) {
      console.log('[Skeepers]', ...args);
    }
  }

  private setProperties(userData: SkeepersUserData): void {
    (window as any)._Mfb_useCookie = true;
    (window as any)._Mfb_ud = {
      Email: userData.email,
      N_contrat: userData.contractNumber,
      Offre: userData.offer,
      _context: {
        lang: userData.lang,
        privacyMode: false,
        _page: {
          url: location.pathname,
          storageDuration: 30,
        },
      },
    };
    this.log('Properties set', (window as any)._Mfb_ud);
  }

  init(userData: SkeepersUserData): void {
    this.setProperties(userData);

    if (document.getElementById(this.SCRIPT_ID)) {
      this.log('SDK already loaded, calling start() directly');
      this.start();
      return;
    }

    this.log('Injecting SDK script…', this.SCRIPT_SRC);

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.id = this.SCRIPT_ID;
    script.src = this.SCRIPT_SRC;
    script.onload = () => {
      this.log('SDK loaded successfully ✓');
      this.start();
    };
    script.onerror = () => {
      console.error('[Skeepers] Failed to load SDK from', this.SCRIPT_SRC);
    };

    const firstScript = document.getElementsByTagName('script')[0] as HTMLScriptElement | undefined;
    if (firstScript?.parentNode) {
      firstScript.parentNode.insertBefore(script, firstScript);
    } else {
      document.head.appendChild(script);
    }
  }

  /** Script 3 — Triggers the feedback widget if the SDK is ready. */
  private start(): void {
    if (typeof this.mfb !== 'undefined') {
      this.log('MFB.start() called — evaluating trigger rules');
      this.mfb.start();
    } else {
      console.warn('[Skeepers] MFB not available when start() was called');
    }
  }
}
